<template>
  <div class="neibianj">
    <el-row class="tree-content w100 mab_20" type="flex" :gutter="20">
      <el-col :span="24">
        <div class="filter-inline-panel cle">
          <el-form :inline="true" size="mini" :model="filterForm" class="filter-panel">
          </el-form>
          <div class="list-opinion fr">
            <el-button type="primary" v-if="hasBtn('btn_add')" size="mini" @click="articleEdit()">新建</el-button>
          </div>
        </div>
        <el-table :data="list" size="mini" v-if="list" border>
          <el-table-column prop="name" align="center" label="名称"></el-table-column>
          <el-table-column prop="address" align="center" label="存放地点"></el-table-column>
          <el-table-column prop="num" align="center" label="数量"></el-table-column>
          <el-table-column prop="use_people" align="center" label="使用人"></el-table-column>
          <el-table-column prop="update_time" align="center" label="更新时间">
          	<template slot-scope="scope"> {{getTime(scope.row.update_time)}} </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="articleEdit(scope.row)">编辑</el-button>
              <el-button size="mini" type="info" @click="articleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="tree-content" type="flex" :gutter="20">
      <el-col :span="24" class="page-pagination">
        <el-pagination style="float:right;" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="编辑" width="1000px" :visible="editFormVisible" @close="editFormVisible = false">
      <el-form :model="editForm" label-position="top" size="mini" :rules="editFormRules" ref="editForm">
        <el-row class="tree-content w100" :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input v-model="editForm.name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="存放地点" prop="address">
              <el-input v-model="editForm.address" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数量" prop="num">
              <el-input v-model="editForm.num" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="使用人" prop="use_people">
              <el-input v-model="editForm.use_people" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" size="mini" @click.native="articleAction('editForm')">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import EditorBar from '../../components/wangEnduit.vue'
import global   from  '../../global.vue'
export default {
	name: '',
	components: {
		EditorBar
	},
	data() {
		return {
			http:global.http,
			isClear: false,
			editForm: {
				address: '',
				num: '',
				use_people: '',
				name: '',
			},
			editFormRules: {
				title: [{
					required: true,
					message: '请输入问题',
					trigger: 'blur'
				}],
				content: [{
					required: true,
					message: '请输入答案',
					trigger: 'blur'
				}],
			},
			editFormVisible: false,
			filterForm: {},
			type: '',
			list: [],
			pages: {
				page: 1,
				count: 100,
				perpage: 10,
			},
			NEWS_TYPE:{},
		};
	},
	// 初始事件
	mounted: function () {
		// this.config();
		this.init();
	},
	methods: {
		config() {
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code: 'NEWS_TYPE',
			}
			this_.$post(url, datas).then((res) => {
				this_.NEWS_TYPE = res.NEWS_TYPE;
				this_.init();
			})
		},
		init() {
			var this_ = this;
			var url = "FixedList";
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
			}
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		articleDelete(index, data) {
			var this_ = this;
			var url = "FixedDelete";
			var datas = {
				id: data.id
			}
			this_.$confirm('确认删除吗?', '提示', {
				//type: 'warning'
			}).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success('删除成功');
					this_.init();
				})
			}).catch(() => {});
		},
		articleEdit(e) {
			if (e) {
				this.editForm = e;
			} else {
				this.editForm = {
					address: '',
					num: '',
					use_people: '',
					name: '',
				}
			}
			this.editFormVisible = true;
		},
		// 保存
		articleAction(editForm) {
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var url = "FixedAction";
					var datas = {
						address: this_.editForm.address,
						num: this_.editForm.num,
						use_people: this_.editForm.use_people,
						name: this_.editForm.name,
					}
					var tishi = '添加成功';
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = '修改成功';
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		// 图片上传
		imageSuccess(res, file) {
			if (res.status == 200) {
				this.editForm.image = res.data.showname;
				this.editForm.image_ry = res.data.savename;
			} else {
				his_.$message.success(res.message);
			}
		},


		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	}
}
</script>
<style scoped>
.neibianj {
	padding: 1px;
}
.filter-inline-panel {
	margin-bottom: 10px;
}

</style>
<style type="text/css">
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 100px;
	height: 100px;
	line-height: 100px;
	text-align: center;
}
.avatar {
	width: 100px;
	height: 100px;
	display: block;
}
.mab_20{
	margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/list/fixed.vue